export default __webpack_public_path__ + "static/media/mumbai3.c1362408.jpg";